import React from "react"
import CardTravelIcon from "@mui/icons-material/CardTravel"
import LocalShippingIcon from "@mui/icons-material/LocalShipping"
import { Box, Stack, Typography } from "@mui/material"
import { COLORS } from "../../../utils"

const sx = {
  reprodChip: {
    backgroundColor: COLORS.GREEN_SUCCESS_100,
    borderRadius: "43px",
    padding: "8px 16px",
  },
  reprod: {
    fontSize: 14,
    lineHeight: 1,
    color: COLORS.LABEL_GREY,
    fontWeight: 400,
  }
}
const SectionParticularities = ({ nationalSend, lunchbag, reprod }) => {
  if (!nationalSend && !lunchbag && !reprod) {
    return null
  }

  return (
    <Stack direction="column" spacing={1}>
      {nationalSend && <LocalShippingIcon />}
      {lunchbag && <CardTravelIcon />}
      {reprod && (
        <Box sx={sx.reprodChip} className="flexCenter">
          <Typography sx={sx.reprod}>Reprod</Typography>
        </Box>
      )}
    </Stack>
  )

}

export default SectionParticularities